import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "upload_body"
};
const _hoisted_2 = {
  class: "navbat"
};
const _hoisted_3 = {
  class: "upload_body_nr"
};
const _hoisted_4 = {
  class: "upload_list"
};
const _hoisted_5 = {
  class: "upListImg"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "upLIst_r"
};
const _hoisted_8 = {
  style: {
    "margin-bottom": "20px",
    "font-size": "30px"
  }
};
const _hoisted_9 = {
  style: {
    "font-size": "2rem",
    "text-indent": "4rem",
    "overflow": "hidden",
    "text-overflow": "ellipsis",
    "display": "-webkit-box",
    "-webkit-line-clamp": "2",
    "-webkit-box-orient": "vertical"
  }
};
const _hoisted_10 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/imgs/fh.png",
    alt: "",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.fh && $setup.fh(...args))
  }), _cache[1] || (_cache[1] = _createElementVNode("span", null, "公益活动", -1))]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.upList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index
    }, [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
      src: item.coverUrl,
      style: {
        "width": "100%",
        "height": "100%",
        "object-fit": "cover"
      },
      alt: ""
    }, null, 8, _hoisted_6)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", null, [_createElementVNode("h3", _hoisted_8, _toDisplayString(item.benefitName), 1), _createElementVNode("span", _hoisted_9, _toDisplayString(item.benefitExplain), 1)]), _createElementVNode("div", {
      class: "btn",
      onClick: $event => $setup.go(item.id),
      style: {
        "font-size": "25px"
      }
    }, " 去参与 ", 8, _hoisted_10)])]);
  }), 128))])])]);
}